import { fixedDepositsConstants } from "../_constants";

export const fixedDepositsListRequest = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_LIST_REQUEST,
    payload,
  };
};

export const fixedDepositsListComplete = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_LIST_COMPLETE,
    payload,
  };
};

export const fixedDepositsListError = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_LIST_ERROR,
    payload,
  };
};

export const fixedDepositsProductDetailsRequest = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_PRODUCT_DETAILS_REQUEST,
    payload,
  };
};

export const fixedDepositsProductDetailsComplete = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_PRODUCT_DETAILS_COMPLETE,
    payload,
  };
};

export const fixedDepositsProductDetailsError = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_PRODUCT_DETAILS_ERROR,
    payload,
  };
};

export const fixedDepositsOpenInitiateRequest = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_OPEN_INITIATE_REQUEST,
    payload,
  };
};

export const fixedDepositsOpenInitiateComplete = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_OPEN_INITIATE_COMPLETE,
    payload,
  };
};

export const fixedDepositsOpenInitiateError = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_OPEN_INITIATE_ERROR,
    payload,
  };
};
export const fixedDepositsRateListRequest = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_RATE_LIST_REQUEST,
    payload,
  };
};

export const fixedDepositsRateListComplete = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_RATE_LIST_COMPLETE,
    payload,
  };
};

export const fixedDepositsRateListError = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_RATE_LIST_ERROR,
    payload,
  };
};

export const fixedDepositsEligibleCasaListRequest = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_REQUEST,
    payload,
  };
};

export const fixedDepositsEligibleCasaListComplete = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_COMPLETE,
    payload,
  };
};

export const fixedDepositsEligibleCasaListError = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_ERROR,
    payload,
  };
};

export const setFixedDepositProductType = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSIT_PRODUCT_TYPE,
    payload,
  };
};

export const setFixedDepositProductCode = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSIT_PRODUCT_CODE,
    payload,
  };
};

export const setFixedDepositPayableMethod = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSIT_PAYABLE_METHOD,
    payload,
  };
};

export const clearFixedDeposits = (payload) => {
  return {
    type: fixedDepositsConstants.CLEAR_FIXED_DEPOSITS,
    payload,
  };
};

export const clearFixedDepositsReceipt = (payload) => {
  return {
    type: fixedDepositsConstants.CLEAR_FIXED_DEPOSITS_RECEIPT,
    payload,
  };
};

export const setFixedDepositPeriod = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSIT_PERIOD,
    payload,
  };
};

export const setFixedDepositEligibleCasaAccount = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSITS_ELIGIBLE_CASA_ACCOUNT,
    payload,
  };
};

export const setFixedDepositEligibleInterestPayableCasaAccount = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSITS_ELIGIBLE_INTEREST_PAYABLE_CASA_ACCOUNT,
    payload,
  };
};

export const setFixedDepositAutomaticRenewal = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSITS_AUTOMATIC_RENEWAL,
    payload,
  };
};

export const setFixedDepositPrincipalAmount = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSITS_PRINCIPAL_AMOUNT,
    payload,
  };
};

export const setFixedDepositMaturityAmount = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSITS_MATURITY_AMOUNT,
    payload,
  };
};

export const setFixedDepositOpenInitiate = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSIT_OPEN_INITIATE,
    payload,
  };
};
export const setFixedDepositInterestAmount = (payload) => {
  return {
    type: fixedDepositsConstants.SET_FIXED_DEPOSITS_INTEREST_AMOUNT,
    payload,
  };
};

export const fixedDepositsOtpConfirmationRequest = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_OTP_CONFIRMATION_REQUEST,
    payload,
  };
};

export const fixedDepositsOtpConfirmationComplete = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_OTP_CONFIRMATION_COMPLETE,
    payload,
  };
};

export const fixedDepositsOtpConfirmationError = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_OTP_CONFIRMATION_ERROR,
    payload,
  };
};

export const fixedDepositsOtpResendRequest = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_OTP_RESEND_REQUEST,
    payload,
  };
};

export const fixedDepositsOtpResendComplete = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_OTP_RESEND_COMPLETE,
    payload,
  };
};

export const fixedDepositsOtpResendError = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_OTP_RESEND_ERROR,
    payload,
  };
};

export const fixedDepositReceiptRequest = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_RECEIPT_REQUEST,
    payload,
  };
};

export const fixedDepositReceiptComplete = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_RECEIPT_COMPLETE,
    payload,
  };
};

export const fixedDepositReceiptError = (payload) => {
  return {
    type: fixedDepositsConstants.FIXED_DEPOSITS_RECEIPT_ERROR,
    payload,
  };
};
